import { render, staticRenderFns } from "./FormCrudShop.vue?vue&type=template&id=35b668e8&scoped=true&"
import script from "./FormCrudShop.vue?vue&type=script&lang=js&"
export * from "./FormCrudShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b668e8",
  null
  
)

export default component.exports